import '../../scss/controls/_card.scss';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleDown, faAngleDoubleUp } from '@fortawesome/free-solid-svg-icons';

export enum CardHeaderTheme {
    White = 'white',
    Blue = 'blue',
    Red = 'red',
    Gray = 'gray',
    Yellow = 'yellow',
}
export enum CardTheme {
    White = 'white',
    Blue = 'blue',
    Red = 'red',
    Gray = 'gray',
    Yellow = 'yellow',
    Transparent = 'transparent',
}

export enum CardBorderStyle {
    None = 'noBorder',
    Solid = 'solidBorder',
    SolidDarkerBorder = 'solidDarkerBorder',
}

export enum CardBorderRadius {
    None = 'noRadius',
    Small = 'smallRadius',
    Medium = 'mediumRadius',
}

export const Card: React.FC<{
    header: any;
    children: any;
    headerTheme: CardHeaderTheme;
    theme: CardTheme;
    width?: string;
    height?: string;
    padding?: number;
    borderStyle?: string;
    borderRadius?: string;
    showHeaderSeperator?: boolean;
    collapsible?: boolean;
    defaultCollapsed?: boolean;
}> = ({
    header,
    children,
    headerTheme,
    theme,
    width = 'auto',
    height = 'auto',
    padding = 'auto',
    borderStyle = CardBorderStyle.None,
    borderRadius = CardBorderRadius.None,
    showHeaderSeperator = false,
    collapsible = false,
    defaultCollapsed = false,
}) => {
    const [collapsed, setCollapsed] = React.useState(defaultCollapsed);

    const setStyle = {
        width: `${width}`,
        height: `${height}`,
        padding: `${padding}px`,
    };

    const toggleCollapsed = () => {
        if (collapsible) setCollapsed((prev) => !prev);
    };

    return (
        <>
            <div
                className={`cardControl ${theme} ${borderStyle} ${borderRadius}`}
                style={setStyle}
            >
                <div
                    className={`cardControl-header ${headerTheme} ${showHeaderSeperator ? 'showHeaderSeperator' : ''} ${borderStyle} ${borderRadius}`}
                    style={{ cursor: collapsible ? 'pointer' : 'default' }}
                    onClick={toggleCollapsed}
                >
                    <div className='card-header-inner'>
                        <div className='card-header-text'>{header}</div>{' '}
                        {collapsible && (
                            <div title={collapsed ? 'Expand Down' : 'Collapse'}>
                                <FontAwesomeIcon icon={collapsed ? faAngleDoubleDown : faAngleDoubleUp} />
                            </div>
                        )}
                    </div>
                </div>
                {!collapsed && <div className={`cardControl-content ${theme}`}>{children}</div>}
            </div>
        </>
    );
};
